import { render } from "./TaskSettingsCustomFields.vue?vue&type=template&id=34cf97be"
import script from "./TaskSettingsCustomFields.vue?vue&type=script&lang=js"
export * from "./TaskSettingsCustomFields.vue?vue&type=script&lang=js"

const cssModules = {}
import style0 from "./TaskSettingsCustomFields.vue?vue&type=style&index=0&id=34cf97be&module=true&lang=less"
cssModules["$style"] = style0

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__cssModules',cssModules]])

export default __exports__